// Imposta dinamicamente la dimensione fisica della pagina di stampa subito
// prima di window.print(). Le regole @page multiple con un nome diverso per
// formato (es. "@page label62x100 { size: 100mm 62mm; } .foo { page: label62x100; }")
// si sono rivelate NON affidabili in Chrome/Chromium (verificato generando un
// PDF di stampa reale: il browser ignora l'assegnazione e usa comunque il
// formato di default, tipicamente Letter). Un'unica regola @page senza nome,
// riscritta ogni volta appena prima di stampare, funziona in modo affidabile
// perché non richiede la selezione di una pagina con nome tra tante.
const STYLE_ID = "dynamic-print-page-size";

export function setPrintPageSize(widthMm, heightMm) {
  let style = document.getElementById(STYLE_ID);
  if (!style) {
    style = document.createElement("style");
    style.id = STYLE_ID;
    document.head.appendChild(style);
  }
  style.textContent = `@page { size: ${widthMm}mm ${heightMm}mm; margin: 0; }`;
}

export function clearPrintPageSize() {
  document.getElementById(STYLE_ID)?.remove();
}
